import { Table } from "@/features/Table";
import { type EtfStaticData, etf_static_data_columns } from "./columns";
import { type FilterEtfStaticDataSchema, FilterEtfStaticData } from "./filter";
import { useLocation } from "react-router";

const client = "instit-quantilia";
const table_name = "etf_static_data";

export const EtfStaticDataTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<EtfStaticData, FilterEtfStaticDataSchema>
      label="Static Data of ETFs"
      client={client}
      table_name={table_name}
      columns={etf_static_data_columns}
      filter={<FilterEtfStaticData />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
